
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BaseHttpClientService } from './base-http-client.service';

@Injectable()
export class LoggerService extends BaseHttpClientService {
  constructor(
    private http: HttpClient,
  ) {
    super()
  }

  public logToServer(userId: any, logMessage: string) {
    logMessage = `PortalLogger :: skylarkUserId ${userId} :: ${logMessage}`;

    console.log(logMessage);
    this.http.post(environment.apiUrl + 'management/remote-log', logMessage).subscribe();
  }
}
